import React from "react";
import { CheckCircle, Users, MapPin, Calendar } from "lucide-react";
import { aboutData, companyInfo } from "../data/mock";

export const About = () => {
  const highlights = [
    {
      icon: Calendar,
      label: "Gegründet 2010",
      description: "Über 15 Jahre Erfahrung",
    },
    {
      icon: MapPin,
      label: "Standort Illertal",
      description: "Deutschlandweiter Service",
    },
    {
      icon: Users,
      label: "B2B-Fokus",
      description: "Für Gerüstbauer & Bau",
    },
  ];

  return (
    <section id="ueber-uns" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image/Visual */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="aspect-[4/3] relative">
                <img 
                  src="/images/werkstatt.png"
                  alt="Werkstatt Gerüst Sanierung - Robert Recher bei der Arbeit"
                  className="absolute inset-0 w-full h-full object-cover grayscale"
                />
                {/* Overlay with info */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <span className="text-lg font-bold">GS</span>
                    </div>
                    <div>
                      <p className="font-medium">Werkstatt & Materialien</p>
                      <p className="text-sm opacity-80">Sterngasse 5, Balzheim</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 hidden sm:block">
              <div className="text-center">
                <div className="text-4xl font-bold text-primary">15+</div>
                <div className="text-sm text-secondary mt-1">Jahre Erfahrung</div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <span className="inline-block text-accent font-semibold text-sm tracking-wider uppercase mb-4">
              Über uns
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-6">
              {companyInfo.fullName}
            </h2>
            <p className="text-lg text-secondary leading-relaxed mb-8">
              {aboutData.text}
            </p>

            {/* Highlights */}
            <div className="space-y-4 mb-8">
              {highlights.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 bg-neutral-light rounded-xl hover:bg-primary/5 transition-colors"
                  >
                    <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <IconComponent className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-primary">{item.label}</h4>
                      <p className="text-secondary text-sm">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Value Props */}
            <div className="flex flex-wrap gap-3">
              {["Wirtschaftlich", "Fachgerecht", "Transparent"].map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-2 bg-accent/10 text-primary px-4 py-2 rounded-full text-sm font-medium"
                >
                  <CheckCircle className="w-4 h-4 text-accent" />
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
